import { CommitmentsPeriodsService_lifePeriodsVersionServiceGetPaidUpPeriods } from '@festina/life-general-types/life/hooks/CommitmentsPeriodsService_lifePeriodsVersionServiceGetPaidUpPeriods'

export const useFetchPaidUpPeriods =
  CommitmentsPeriodsService_lifePeriodsVersionServiceGetPaidUpPeriods.useSuspenseQuery
